import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/api';
import useToast from '../hooks/useToast';
import './ETPOS/Products.css';
import './ETPOS/MobileResponsive.css';

const AddAgent = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToast();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    surname: '',
    first_name: '',
    last_name: '',
    email: '',
    contact_no: '',
    address: '',
    cmmsn_percent: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.first_name.trim()) {
      showError('First Name is required');
      return;
    }

    try {
      setLoading(true);
      const payload = {
        surname: formData.surname,
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        contact_no: formData.contact_no,
        address: formData.address,
        cmmsn_percent: formData.cmmsn_percent ? parseFloat(formData.cmmsn_percent) : 0
      };

      const res = await apiService.createSalesCommissionAgent(payload);
      if (res && (res.success || res.status || res.id || res.data)) {
        showSuccess('Sales Commission Agent added successfully!');
        navigate('/users', { state: { activeTab: 'agents' } });
      } else {
        showError(res?.message || 'Failed to add sales commission agent');
      }
    } catch (err) {
      /* console.error('Error adding sales commission agent:', err); */
      showError(err.message || 'Failed to add sales commission agent');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="products-container" style={{ padding: '1.5rem', maxWidth: '900px', margin: '0 auto' }}>
      <div className="main-card" style={{ background: '#ffffff', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', padding: '1.75rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', borderBottom: '1px solid #f1f5f9', paddingBottom: '1rem' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '1.35rem', fontWeight: '800', color: '#0f172a' }}>Add Sales Commission Agent</h2>
            <p style={{ margin: '0.25rem 0 0', fontSize: '0.85rem', color: '#64748b' }}>Create a new sales commission agent for tracking agent sales and commissions.</p>
          </div>
          <button className="control-btn-primary" onClick={() => navigate('/users', { state: { activeTab: 'agents' } })} style={{ background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }}>
            ← Back to Agents
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.25rem', marginBottom: '1.5rem' }}>
            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: '700', color: '#334155' }}>Prefix / Title:</label>
              <select name="surname" value={formData.surname} onChange={handleChange} style={{ padding: '0.55rem 0.75rem', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem' }}>
                <option value="">Select Prefix</option>
                <option value="Mr">Mr.</option>
                <option value="Mrs">Mrs.</option>
                <option value="Ms">Ms.</option>
                <option value="Dr">Dr.</option>
              </select>
            </div>

            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: '700', color: '#334155' }}>First Name: <span style={{ color: '#ef4444' }}>*</span></label>
              <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} required placeholder="First Name" style={{ padding: '0.55rem 0.75rem', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem' }} />
            </div>

            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: '700', color: '#334155' }}>Last Name:</label>
              <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} placeholder="Last Name" style={{ padding: '0.55rem 0.75rem', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem' }} />
            </div>

            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: '700', color: '#334155' }}>Email Address:</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="agent@example.com" style={{ padding: '0.55rem 0.75rem', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem' }} />
            </div>

            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: '700', color: '#334155' }}>Contact Number:</label>
              <input type="text" name="contact_no" value={formData.contact_no} onChange={handleChange} placeholder="Contact Number" style={{ padding: '0.55rem 0.75rem', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem' }} />
            </div>

            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: '700', color: '#334155' }}>Sales Commission Percentage (%):</label>
              <input type="number" step="0.01" min="0" max="100" name="cmmsn_percent" value={formData.cmmsn_percent} onChange={handleChange} placeholder="e.g. 5.50" style={{ padding: '0.55rem 0.75rem', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem' }} />
            </div>
          </div>

          <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', marginBottom: '1.75rem' }}>
            <label style={{ fontSize: '0.85rem', fontWeight: '700', color: '#334155' }}>Address:</label>
            <textarea name="address" rows="3" value={formData.address} onChange={handleChange} placeholder="Agent Address" style={{ padding: '0.55rem 0.75rem', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', width: '100%', resize: 'vertical' }} />
          </div>

          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', borderTop: '1px solid #f1f5f9', paddingTop: '1.25rem' }}>
            <button type="button" className="control-btn-primary" onClick={() => navigate('/users', { state: { activeTab: 'agents' } })} style={{ background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }}>
              Cancel
            </button>
            <button type="submit" disabled={loading} className="control-btn-primary" style={{ background: 'linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)', color: '#ffffff', border: 'none' }}>
              {loading ? 'Saving...' : 'Save Agent'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAgent;
